import { HubSpotSaveObjectsConfig } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getHubspotSaveObjectsTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as HubSpotSaveObjectsConfig;

	return [
		{
			id: 'use-variable-token',
			selector: '[data-tour="use-variable-token"]',
			content:
				'This option changes the Access Token input behavior to allow free text or expression inputs.',
		},
		{
			id: 'access-token',
			selector: '[data-tour="access-token"]',
			content: 'Required: The HubSpot access token that will be used to validate the request.',
		},
		...(config.accessToken.trim().length > 0
			? [
					{
						id: 'object-type',
						selector: '[data-tour="object-type"]',
						content:
							'Required: Once a valid HubSpot access token is provided the task will fetch a list of available objects from the HubSpot environment.',
					},
					{
						id: 'batch-entry',
						selector: '[data-tour="batch-entry"]',
						content:
							"This is used to choose whether to process all records at once or one at a time. Processing all items at once will use Hubspot's batch API and increase task performance, whereas processing items one at a time will send separate requests for each record.",
					},
					{
						id: 'batch-entry',
						selector: '[data-tour="batch-entry"]',
						content:
							"This is used to choose whether to process all records at once or one at a time. Processing all items at once will use Hubspot's batch API and increase task performance, whereas processing items one at a time will send separate requests for each record.",
					},
					...(config.singleExecute
						? [
								{
									id: 'hs-object-id',
									selector: '[data-tour="hs-object-id"]',
									content:
										'This is used to determine the property that will be matched to existing tasks in Hubspot when doing updates.',
								},
							]
						: [
								{
									id: 'batch-create',
									selector: '[data-tour="batch-create"]',
									content: 'Perform a direct object creation on hubspot in a batch.',
								},
								...(!config.batchCreate
									? [
											{
												id: 'object-id',
												selector: '[data-tour="object-id"]',
												content:
													'Required: This is used to determine the property that will be matched to existing tasks in Hubspot when doing updates.',
											},
										]
									: []),
							]),

					{
						id: 'auto-map-fields',
						selector: '[data-tour="auto-map-fields"]',
						content:
							'This is used to generate all field mappings that exist on the selected object type in Hubspot.',
					},
					{
						id: 'add-mapping-field',
						selector: '[data-tour="add-mapping-field"]',
						content:
							'This is used to add a single field mapping. Field mappings are used to choose which properties will be saved when creating or updating objects in Hubspot.',
					},
					...(config.fieldMappings.length > 0
						? [
								{
									id: 'upsert-object-field',
									selector: '[data-tour="upsert-object-field"]',
									content:
										'Required: This is used to select the field which will be populated from the Incoming Object Field.',
								},
								{
									id: 'incoming-object-field',
									selector: '[data-tour="incoming-object-field"]',
									content:
										'Required: This is used to choose data from the input coming into the task.',
								},
							]
						: []),
				]
			: []),
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
